import { Line } from "@react-three/drei";
import { GroupProps, useFrame, Vector3 } from "@react-three/fiber";
import { useRef } from "react";
import { SERIF } from "../../constants";
import { useSettings } from "../../hooks/useSettings";

interface PropsType extends GroupProps {
    width: number;
    isIndent: boolean;
    position: Vector3;
}

export const DimensionSectionHorizontal = ({ width, isIndent, position, ...props }: PropsType) => {
    const groupRef = useRef<any>(null);
    const ref = useRef<any>(null);

    useFrame(() => {
        if (groupRef.current) {
            groupRef.current.scale.x = width / 1000 - 0.04;
            groupRef.current.position.x = -width / 1000 + 0.02;
            groupRef.current.position.z = 0.1;
        }
    });

    const { isVisibleSizes } = useSettings();
    if (!isVisibleSizes) {
        return null;
    }

    return (
        <group position={position} {...props}>
            <group ref={groupRef}>
                <Line
                    ref={ref}
                    points={[
                        [0, 0, 0],
                        [1, 0, 0],
                    ]}
                    lineWidth={2}
                    color="white"
                />
                <Line
                    points={[
                        [0, -SERIF, 0],
                        [0, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
                <Line
                    points={[
                        [1, -SERIF, 0],
                        [1, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
            </group>
        </group>
    );
};
